import React, { useEffect, useState } from "react";
import { collection, onSnapshot, query, orderBy } from "firebase/firestore";
import { db } from "../firebase";

const threatConfig = {
  bushfires: {
    type: "Bushfire",
    icon: "/fire.png",
    color: "#EF4444",
    bg: "#FFE3E3",
  },
  poaching: {
    type: "Poaching", 
    icon: "/hunt.png",
    color: "#92400E",
    bg: "#FFF3C4",
  },
  deforestation: {
    type: "Deforestation",
    icon: "/forest.png",
    color: "#15803D",
    bg: "#E1F7E1",
  },
};

const WildlifeThreatsPanel = () => {
  const [threatsData, setThreatsData] = useState([]);

  useEffect(() => {
    const unsubscribes = [];
    const groupedData = {
      bushfires: { count: 0, lastTime: null },
      poaching: { count: 0, lastTime: null },
      deforestation: { count: 0, lastTime: null }
    };

    // Alert collections to monitor
    const alertCollections = [
      'drone-bushfire-alerts',
      'drone-deforestation-alerts', 
      'drone-poaching-alerts',
      'iot-bushfire-alerts',
      'iot-deforestation-alerts',
      'iot-poaching-alerts'
    ];

    // Listen to all alert collections
    alertCollections.forEach(collectionName => {
      const q = query(collection(db, collectionName), orderBy("timestamp", "desc"));
      const unsubscribe = onSnapshot(q, (snapshot) => {
        // Determine threat type from collection name
        let threatType = '';
        if (collectionName.includes('bushfire')) threatType = 'bushfires';
        else if (collectionName.includes('deforestation')) threatType = 'deforestation';
        else if (collectionName.includes('poaching')) threatType = 'poaching';

        if (threatType) {
          // Reset count for this threat type from this collection
          const currentCount = snapshot.docs.filter(doc => {
            const data = doc.data();
            // Apply same confidence filter as main page
            return !data.hasOwnProperty('confidence') || data.confidence === undefined || data.confidence > 0.24;
          }).length;

          // Update count
          groupedData[threatType].count = (groupedData[threatType].count || 0) + currentCount;

          // Update last time if we have docs
          if (snapshot.docs.length > 0) {
            const latestDoc = snapshot.docs[0].data();
            const latestTime = latestDoc.timestamp?.toDate?.();
            if (!groupedData[threatType].lastTime || latestTime > groupedData[threatType].lastTime) {
              groupedData[threatType].lastTime = latestTime;
            }
          }

          // Update the state with current grouped data
          const result = Object.entries(threatConfig).map(([key, cfg]) => ({
            ...cfg,
            count: groupedData[key]?.count || 0,
            time: groupedData[key]?.lastTime
              ? groupedData[key].lastTime.toLocaleString()
              : "—",
          }));

          setThreatsData(result);
        }
      }, (error) => {
        console.error(`Error fetching from ${collectionName}:`, error);
      });
      
      unsubscribes.push(unsubscribe);
    });

    return () => unsubscribes.forEach(unsub => unsub());
  }, []);

  return (
    <div className="panel threats-panel">
      <div className="panel-header">
        <h3>Wildlife Threats</h3>
        <a href="#">View All</a>
      </div>

      <div className="threats-grid">
        {threatsData.map((threat, idx) => {
          return (
            <div key={idx} className="threat-card" style={{ backgroundColor: threat.bg }}>
              <div className="threat-count" style={{ color: threat.color }}>
                <span className="threat-num">{threat.count}</span>
                <img 
                  src={threat.icon} 
                  alt={threat.type}
                  className="threat-icon" 
                  style={{ width: '24px', height: '24px' }} 
                />
              </div>
              <div className="threat-info">
                <div className="threat-type">{threat.type}</div>
                <div className="threat-time">Last time: {threat.time}</div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="threat-buttons">
        <button className="view-location-btn">View Location</button>
        <button className="call-emergency-btn">Call Emergency</button>
      </div>
    </div>
  );
};

export default WildlifeThreatsPanel;
